import { Link, NavLink, useNavigate, Outlet } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const NAV = [
    { to: "/portal", label: "Trip Overview", end: true },
    { to: "/portal/itinerary", label: "Day by Day" },
    { to: "/portal/documents", label: "Documents" },
    { to: "/portal/messages", label: "Concierge" },
  ];

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-ivory text-ink flex flex-col md:flex-row">
      <aside className="md:w-72 md:min-h-screen bg-jade text-ivory md:sticky md:top-0 md:self-start">
        <div className="p-8 md:p-10 flex md:flex-col gap-6 justify-between md:justify-start md:h-screen">
          <div>
            <Link to="/" className="font-serif text-2xl text-ivory">Abbot <span className="italic text-copper">Asia</span></Link>
            <p className="eyebrow text-copper mt-3 hidden md:block">Client Portal</p>
            <nav className="hidden md:flex flex-col gap-3 mt-12">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.end}
                  data-testid={`portal-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                  className={({ isActive }) =>
                    `text-[13px] tracking-[0.16em] uppercase py-2 transition-colors ${
                      isActive ? "text-copper" : "text-ivory/75 hover:text-ivory"
                    }`
                  }
                >{n.label}</NavLink>
              ))}
            </nav>
          </div>

          <div className="md:mt-auto">
            <div className="hidden md:block divider-thin opacity-30 mb-6" />
            <p className="eyebrow text-ivory/60">Signed in as</p>
            <p className="mt-2 font-serif text-xl text-ivory">{user?.name}</p>
            <p className="text-[12px] text-ivory/60 truncate">{user?.email}</p>
            <button data-testid="portal-logout" onClick={onLogout} className="mt-5 inline-flex items-center gap-2 text-[12px] tracking-[0.16em] uppercase text-ivory/70 hover:text-copper">
              <LogOut className="w-4 h-4" strokeWidth={1} /> Sign out
            </button>
          </div>
        </div>

        {/* Mobile horizontal nav */}
        <div className="md:hidden border-t border-ivory/15">
          <nav className="flex overflow-x-auto px-6 py-4 gap-6">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `whitespace-nowrap text-[12px] tracking-[0.16em] uppercase ${isActive ? "text-copper" : "text-ivory/70"}`
                }
              >{n.label}</NavLink>
            ))}
          </nav>
        </div>
      </aside>

      <main className="flex-1 bg-ivory">
        <Outlet />
      </main>
    </div>
  );
}
